<template>
  <div>
    <div class="tab mgh-0">
      <ul>
        <li :class="{'is-active': activeTab === 'InfoGenerale'}"
          @click="activeTab = 'InfoGenerale'">
          {{ $t('dispositifPublicitaire.infoGeneral') }}
        </li>
        <li :class="{'is-active': activeTab === 'InfoTechnique'}"
          @click="activeTab = 'InfoTechnique'">
          {{ $t('dispositifPublicitaire.infoTechnique') }}
        </li>
        <li :class="{'is-active': activeTab === 'InfoMobilier'}"
          @click="activeTab = 'InfoMobilier'">
          {{ $t('dispositifPublicitaire.infoMobilier') }}
        </li>
        <li :class="{'is-active': activeTab === 'NomenclatureTechnique'}"
          @click="activeTab = 'NomenclatureTechnique'">
          {{ $t('nomenclatureTechnique.title') }}
        </li>
      </ul>
    </div>
    <component
      :is="activeTab"
      :dispositifPublicitaire="dispositifPublicitaire"
      :dispositifTechnique="dispositifPublicitaire.dispositifTechnique"
      :dispositifAccessoires="dispositifPublicitaire.dispositifAccessoires"
      :item="dispositifPublicitaire"
    />
  </div>
</template>

<script>

import InfoMobilier from '@/components/gabed/dispositif/m_infoMobilier';
import InfoTechnique from '@/components/gabed/dispositif/m_infoTechnique';
import InfoGenerale from '@/components/gabed/dispositif/m_infoGenerale';
import NomenclatureTechnique from '@/components/commun/nomenclature/nomenclatureTechnique';

export default {
  name: 'm_dispositifPublicitaire',
  props: {
    dispositifPublicitaire: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      activeTab: 'InfoGenerale',
    };
  },
  components: {
    InfoTechnique,
    InfoGenerale,
    InfoMobilier,
    NomenclatureTechnique,
  },
};
</script>
